import React, { useEffect, useState } from 'react'
import { Radio, Select, Input, Button, Space, Modal, message, Row, Col, Card } from 'antd'

import { observer } from '@/store'
import Store from './store'
import "./style.modules.scss"




const App = ({ item }) => {

  const [value, SetValue] = useState(item.value)
  const [dic, SetDic] = useState(() => {
    if (item.dic) {
      let arr = []
      let arr2 = item.dic.split(',')
      arr2.forEach(v => {
        let arr3 = v.split('|')
        arr.push({
          label: arr3[1],
          value: arr3[0] + ""
        })
      });

      return arr
    }




    return []
  })
  const [selected, SetSelected] = useState(item.value)




  useEffect(() => {

  }, [])
  return (
    <div className='box'>
      <p className='title'>{item.description}</p>
      {item.rw === 1 && !item.dic && <p className='des'>{item.value} {item.unit}</p>}

      {item.dic && item.rw === 1 && <p style={{ textAlign: 'center' }}>

        {/* <p className='des'>{dic.filter(i => i.value === value + "")[0].label} </p> */}


        <Radio.Group
          options={dic.filter(i => i.value === value + "")}
          disabled={true}
          value={value + ""}
          optionType="button"
          buttonStyle="solid"
        />
      </p>}


      {item.dic && item.rw === 2 && <p style={{ textAlign: 'center' }}>
        <Radio.Group
          options={dic}
          onChange={(e) => { if (item.rw === 1) { return } SetValue(e.target.value); Store.onFinish({ item, value: e.target.value }) }}
          value={value + ""}
          optionType="button"
          buttonStyle="solid"
        />
      </p>}



      {item.rw === 2 && !item.dic && <p style={{ display: 'flex', width: '96%', margin: '0 auto' }}><Input value={value} onChange={(e) => { SetValue(e.target.value || "") }} suffix={item.unit} />  <Button type="primary" onClick={() => {
        if (value === "") { message.info("不能传空值"); return }
        Store.onFinish({ item, value })
      }}>提交</Button></p>}



      {item.rules && <p className='des'>{item.rules}</p>}
      {item.explain && <p className='des'>说明：{item.explain}</p>}


    </div>


  )
}

export default observer(App)